import { render, staticRenderFns } from "./LabUploadStepper.vue?vue&type=template&id=7edb1a7d&scoped=true&lang=pug"
import script from "./LabUploadStepper.vue?vue&type=script&lang=ts"
export * from "./LabUploadStepper.vue?vue&type=script&lang=ts"
import style0 from "./LabUploadStepper.vue?vue&type=style&index=0&id=7edb1a7d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb1a7d",
  null
  
)

export default component.exports
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QStepper,QStep,QStepperNavigation,QBtn,QInnerLoading,QSpinner});
